module.exports = __webpack_public_path__ + "img/web_mockup.8d64037f.png";